

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"8","height":"9","viewBox":"0 0 8 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M7.25 1.25L0.75 7.75L7.25 1.25ZM0.75 1.25L7.25 7.75L0.75 1.25Z","fill":"#3C383A"}, []), "\n", h('path', {"d":"M0.75 1.25L7.25 7.75M7.25 1.25L0.75 7.75L7.25 1.25Z","stroke":"current","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, []), "\n"]);
};

        